import { usePicture } from "@brickme/frontend-common/src/picture-edit/picture-edit-context.tsx";
import { useTranslator } from "@brickme/frontend-common/src/i18n/translation.tsx";
import Button from "~/components/button.tsx";
import type { Mode } from "../mode.ts";
import RemoveColourModal from "./remove-colour-modal.tsx";
import GetInstructionsModal from "./get-instructions-modal.tsx";
import { usePalettes } from "../editor-provider.tsx";
import { createDefaultPaletteMode } from "../create-default-picture-configuration.ts";
import classes from "./complete-colours-menu.module.css";
import BarrierButton from "./barrier-button.tsx";
import { useState } from "preact/hooks";

const removeColourModalId = "remove-colour-modal";
const getInstructionsModalId = "get-instructions-modal";

type CompleteColoursMenuProps = {
	readonly code: string;
	readonly numberOfKits: number;
	readonly onChangeMode: (mode: Mode) => void;
	readonly onOpenSummary: () => void;
};

function CompleteColoursMenu({
	code,
	onChangeMode,
	numberOfKits,
	onOpenSummary,
}: CompleteColoursMenuProps) {
	const t = useTranslator();
	const { patchPicture } = usePicture();
	const { kitsPalette } = usePalettes();
	const [hasGottenInstructions, setHasGottenInstructions] = useState(false);
	return (
		<>
			<RemoveColourModal
				id={removeColourModalId}
				onConfirm={() => {
					onChangeMode("kit-only");
					patchPicture({
						paletteMode: createDefaultPaletteMode({ kitsPalette }),
						saturation: 0,
					});
				}}
			/>
			<GetInstructionsModal
				id={getInstructionsModalId}
				numberOfKits={numberOfKits}
				code={code}
				onSuccess={() => setHasGottenInstructions(true)}
			/>
			<div className={classes["bottom-actions"]}>
				<BarrierButton
					barrierLabel={t("Get instructions")}
					barrierComplete={hasGottenInstructions}
					barrierCommandfor={getInstructionsModalId}
					barrierCommand="show-modal"
					label={t("Buy color bricks")}
					onClick={onOpenSummary}
				/>
				<Button
					type="button"
					variant="text-danger"
					commandfor={removeColourModalId}
					command="show-modal"
				>
					{t("Remove color")}
				</Button>
			</div>
		</>
	);
}

export default CompleteColoursMenu;
